export const initiatedByPropertySearch = "PropertySearch";
export const initiatedByOnlineForms = "OnlineForms";
export const initiatedByTrueRoll = "TrueRoll";
